<style>
.timer-show {
  margin-top: -1vh;
  padding-bottom: 1vh;
}
.settings-input>textarea {
  height: 90px;
  resize: none;
}
.form__percentage-field {
    padding-bottom: 0 !important;
}

.form__percentage-field-label {
    color: #2d4d5a !important;
    font-weight: 700;
}

.not-showing {
  padding-bottom: -1rem !important;
}
</style>

<template>
      <div class="form-group--two-columns">
        <div v-if="settings.length >= 1" v-for="(item, index) in settings" class="form-row">
            <el-form-item v-if="item.type === 1" class="item-checkbox">
              <el-checkbox v-model="settings[index].value" :checked="settings[index].value"
                           @change="updateSettings()" :disabled="!overridden || readOnly">{{ $t('management.unit.softwaresettings.' + item.key) }}
              </el-checkbox>
              <div v-if="hasToolTipTranslationKey(item.key)" class="help-tip">
                <p>{{$t('management.softwaresettings.toolTip.' + item.key)}}</p>
              </div>
            </el-form-item>
            <el-form-item class="custom-label" v-if="item.type === 2">
              <span slot="label">{{$t('management.unit.softwaresettings.' + item.key)}}
                <div v-if="!hideTooltip(item.key)" class="help-tip">
                  <p>{{$t('management.softwaresettings.toolTip.' + item.key)}}</p>
                </div>
              </span>
              <el-input v-model="settings[index].value" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
            </el-form-item>
            <el-form-item class="custom-label" v-if="item.type === 3">
              <span slot="label">{{$t('management.unit.softwaresettings.' + item.key)}}
                <div v-if="hasToolTipTranslationKey(item.key)" class="help-tip">
                  <p>{{$t('management.softwaresettings.toolTip.' + item.key)}}</p>
                </div>
              </span>
              <el-input v-model="settings[index].value" :type="item.key === charitiesField ? 'textarea' : 'text'" class="settings-input" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
            </el-form-item>
            <el-form-item class="custom-label" v-if="item.type === 4">
              <span slot="label">{{$t('management.unit.softwaresettings.' + item.key)}}
                <div v-if="!hideTooltip(item.key)" class="help-tip">
                  <p>{{$t('management.softwaresettings.toolTip.' + item.key)}}</p>
                </div>
              </span>
              <el-select v-model="settings[index].value" @change="updateSettings()" :disabled="!overridden || readOnly">
                  <el-option :label="$t('generic.forms.select')"></el-option>
                  <el-option
                          v-for="(option, key) in JSON.parse(settings[index].values)"
                          :label="$t('management.unit.softwaresettings.' + key.replace(/[ :/]/g,''))"
                          :value="key" selected="selected">
                  </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="custom-label" v-if="item.type === 5">
              <span slot="label">{{$t('management.unit.softwaresettings.' + item.key)}}
                <div v-if="hasToolTipTranslationKey(item.key)" class="help-tip">
                  <p>{{$t('management.softwaresettings.toolTip.' + item.key)}}</p>
                </div>
              </span>
              <el-select v-model="selectedValues" multiple :placeholder="$t('generic.forms.select')" @change="updateMultiSelection()" :disabled="!overridden || readOnly">
              <el-option
                v-for="(option, key) in JSON.parse(settings[index].values)"
                :label="option"
                :value="key" selected="selected">
              </el-option>
            </el-select>
            </el-form-item>

            <div v-if="item.type === 6" class="not-showing"></div>
            <div v-if="item.type === 7" class="not-showing"></div>
            <div v-if="item.type === 8" class="not-showing"></div>

            <el-form-item class="custom-label" v-if="item.type === 9">

              <span slot="label">{{$t('management.unit.softwaresettings.' + item.key)}}
                <div v-if="hasToolTipTranslationKey(item.key)" class="help-tip">
                  <p>{{$t('management.softwaresettings.toolTip.' + item.key)}}</p>
                </div>
              </span>

              <el-checkbox :disabled="!overridden || readOnly" v-model="timePickerEnabled" :checked="timePickerEnabled" @change="updateTimeStampSelection()">
                {{$t('management.unit.softwaresettings.timeSelector.enabled')}}
              </el-checkbox>

              <el-time-select :disabled="!overridden || readOnly || !timePickerEnabled" @change="updateTimeStampSelection()"
                v-model="timePickerTimeStamp"
                :picker-options="{start: '00:00', step: '00:30', end: '23:30'}">
              </el-time-select>

            </el-form-item>
          <el-form-item class="custom-label" v-if="item.type === 10">
              <span slot="label">{{$t('management.unit.softwaresettings.' + item.key)}}
                <div v-if="hasToolTipTranslationKey(item.key)" class="help-tip">
                  <p>{{$t('management.softwaresettings.toolTip.' + item.key)}}</p>
                </div>
              </span>
            <el-checkbox :disabled="!overridden || readOnly" v-model="useDefaultValues[index]" :checked="useDefaultValues[index]" @change="updateDefaultValueSelection(index)">
              {{$t('management.unit.softwaresettings.useDefaultValue')}}
            </el-checkbox>
            <div :disabled="!overridden || readOnly" style="display: flex" v-show="!useDefaultValues[index]">
              <el-form-item :prop="item.key">
                <el-input v-model="settings[index].value" type="text" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
              </el-form-item>
              <el-button v-if="overridden && !readOnly" type="primary" v-on:click="generateNewDefaultValue(index)">Generate</el-button>
            </div>
          </el-form-item>

          <div v-if="item.type === 11">
            <el-form-item class="custom-label">
              <span slot="label">{{$t('management.unit.softwaresettings.' + item.key)}}
                <div v-if="hasToolTipTranslationKey(item.key)" class="help-tip">
                  <p>{{$t('management.softwaresettings.toolTip.' + item.key)}}</p>
                </div>
              </span>
            </el-form-item>
            <div class="timer-show" slot="label">
              <vue-timepicker v-model="settings[index].value" @change="updateSettings()" drop-direction="up" :disabled="!overridden || readOnly" format="mm:ss"></vue-timepicker>
            </div>
          </div>

          <div v-if="item.type === 12">
            <el-form-item class="custom-label">
              <span slot="label">{{$t('management.unit.softwaresettings.' + item.key)}}
                <div v-if="hasToolTipTranslationKey(item.key)" class="help-tip">
                  <p>{{$t('management.softwaresettings.toolTip.' + item.key)}}</p>
                </div>
              </span>
            </el-form-item>
            <div class="timer-show" slot="label">
              <vue-timepicker v-model="settings[index].value" @change="updateSettings()" drop-direction="up" :disabled="!overridden || readOnly" format="HH:mm:ss"></vue-timepicker>
            </div>
          </div>

          <div v-if="item.type === 13" class="custom-label">
            <div class="el-form-item__label form__percentage-field">

            <span class="form__percentage-field-label" slot="label">{{$t('management.unit.softwaresettings.' + item.key)}}
                <div v-if="hasToolTipTranslationKey(item.key)" class="help-tip">
                  <p>{{$t('management.unit.toolTip.' + item.key)}}</p>
                </div>
              </span>
            </div>
            <el-form-item :label="$t('management.unit.form.' + item.key)" prop="alarmOn" class="side--label">
                <span class="label--after input-number">%</span>
                <el-input-number id="unit-alarm-on-input" v-model="settings[index].value" :min="0" :max="100" :disabled="!overridden || readOnly"></el-input-number>
            </el-form-item>
          </div>

          <el-form-item class="custom-label" v-if="item.type === 16">
            <span slot="label">
              {{$t('management.unit.softwaresettings.' + item.key)}}
              <div v-if="hasToolTipTranslationKey(item.key)" class="help-tip">
                <p>{{$t('management.softwaresettings.toolTip.' + item.key)}}</p>
              </div>
            </span>
            <el-input
              v-model="settings[index].parsedValue"
              type="password"
              class="settings-input"
              @change="updateMaskedKeys(index)"
              :disabled="!overridden || readOnly">
            </el-input>
          </el-form-item>

        </div>
      </div>
</template>

<script>
  import Vue from 'vue'
  import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

  export default {
    name: 'DqSettingspanel',
    replace: true,
    props: {
      label: '',
      overridden: false,
      settings: {},
      readOnly: false,
      form: {},
      formRules: {}
    },
    data: function () {
      return {
        activeNames: [1],
        settingsNew: [],
        selectedValues: [],
        timePickerEnabled: false,
        timePickerTimeStamp: '',
        managerUnlockDelay: '',
        managerUnlockStartTime: '',
        managerUnlockEndTime: '',
        useDefaultValues: [],
        originalValues: [],
        charitiesField: 'charities'
      }
    },
    mounted () {
      this.updateSettings()
    },
    watch: {
      settings: function () {
        this.updateSettings()
      }
    },
    components: {
      VueTimepicker
    },
    methods: {
      hasToolTipTranslationKey (key) {
        return !Vue.t(`management.softwaresettings.toolTip.${key}`).includes('management.softwaresettings.toolTip')
      },
      updateSettings () {
        this.settingsNew = []
        for (var index in this.settings) {
          if (this.settings[index].type === 5) {
            this.selectedValues = this.settings[index].value.split(',')
          }
          if (this.settings[index].type === 9) {
            this.timePickerEnabled = JSON.parse(this.settings[index].value).enabled
            this.timePickerTimeStamp = JSON.parse(this.settings[index].value).timeStamp
          }
          if (this.settings[index].type === 10) {
            this.useDefaultValues[index] = this.settings[index].value == null
            this.originalValues[index] = this.settings[index].value
            this.form[this.settings[index].key] = this.settings[index].value
            this.updateFormRules(index)
          }
          if (this.settings[index].type === 16) {
            const parsed = JSON.parse(this.settings[index].value)
            this.settings[index].parsedValue = parsed.value // could be null or "*****"
          }
          if (!this.settings.hasOwnProperty(index)) continue
          this.settingsNew.push(this.settings[index])
        }

        this.$store.commit('overrideSettings/setOverrideSettings', { settings: this.settingsNew })
      },
      updateFormRules (index) {
        if (this.useDefaultValues[index]) {
          delete this.formRules[this.settings[index].key]
        } else {
          const values = JSON.parse(this.settings[index].values)
          const key = this.settings[index].key
          this.formRules[key] = [
            { required: values.rules.required, message: Vue.t('generic.forms.errors.required', { field: Vue.t('generic.forms.errors.fields.' + key) }), trigger: 'blur' },
            { min: values.rules.minLength, message: Vue.t('generic.forms.errors.mincharlength', {min: values.rules.minLength}), trigger: 'blur' },
            { max: values.rules.maxLength, message: Vue.t('generic.forms.errors.maxcharlength', {max: values.rules.maxLength}), trigger: 'blur' }
          ]
        }
      },
      updateMultiSelection () {
        for (var index in this.settings) {
          if (this.settings[index].type === 5) {
            this.settings[index].value = this.selectedValues.toString()
          }
        }
      },
      updateMaskedKeys (index) {
        const item = this.settings[index]
        const newValue = item.parsedValue

        if (!newValue) {
          item.value = JSON.stringify({ value: null, override: false })
        } else {
          item.value = JSON.stringify({ value: newValue, override: false })
        }
      },
      updateTimeStampSelection () {
        for (var index in this.settings) {
          if (this.settings[index].type === 9) {
            var tmpJson = JSON.parse(this.settings[index].value)
            tmpJson.enabled = this.timePickerEnabled
            tmpJson.timeStamp = this.timePickerTimeStamp
            this.settings[index].value = JSON.stringify(tmpJson)
          }
        }
      },
      updateDefaultValueSelection (index) {
        this.updateFormRules(index)
        if (this.useDefaultValues[index]) {
          this.settings[index].value = null
        } else {
          this.settings[index].value = this.originalValues[index]
        }
      },
      generateNewDefaultValue (index) {
        const values = JSON.parse(this.settings[index].values)
        this.settings[index].value = this.generateRandomString(values.rules.minLength)
        this.updateSettings()
      },
      generateRandomString (length) {
        const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
        let result = ''
        for (let i = length; i > 0; --i) {
          result += chars[Math.floor(Math.random() * chars.length)]
        }
        return result
      },
      hideTooltip (key) {
        const keysWithoutTooltip = ['unitInitialLanguage', 'defaultLedColor', 'transactionReceiptNumber']
        return keysWithoutTooltip.includes(key)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// settingspanel.vue?34046a28